<template>
    <div class="field grid"
        v-if="level == 'propinsi' || level == 'kabupaten' || level == 'kecamatan' || level == 'kelurahan'"
        >
        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Propinsi :  </label>
        <div class="col-12 md:col-10">
            <Dropdown v-model="modelValue.selected_propinsi" :options="list_propinsi" optionLabel="nama"  />
            <small v-if="list_error.propinsi" id="name-help" class="p-error">Field Propinsi harus diisi</small>
        </div>
    </div>
    <div class="field grid"
        v-if="level == 'kabupaten' || level == 'kecamatan' || level == 'kelurahan'"
        >
        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Kabupaten :  </label>
        <div class="col-12 md:col-10">
            <Dropdown v-model="modelValue.selected_kabupaten" :options="list_kabupaten" optionLabel="nama" />
            <small v-if="list_error.kabupaten" id="name-help" class="p-error">Field Kabupaten harus diisi</small>
        </div>
    </div>
    <div class="field grid" 
         v-if="level == 'kecamatan' || level == 'kelurahan'"
         >
        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Kecamatan :  </label>
        <div class="col-12 md:col-10">
            <Dropdown v-model="modelValue.selected_kecamatan" :options="list_kecamatan" optionLabel="nama" />
            <small v-if="list_error.kecamatan" id="name-help" class="p-error">Field Kecamatan harus diisi</small>
        </div>
    </div>
    <div class="field grid" v-if="level=='kelurahan'">
        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Kelurahan :  </label>
        <div class="col-12 md:col-10">
            <Dropdown v-model="modelValue.selected_kelurahan" :options="list_kelurahan" optionLabel="nama" />
            <small v-if="list_error.kelurahan" id="name-help" class="p-error">Field Kelurahan harus diisi</small>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Dropdown from 'primevue/dropdown';
export default {
    props: {
        level : {
            type : String,
            default : 'kecamatan'
        },
        modelValue : {
            type : Object,
            default : null
        },
        list_error : {
            type : Object,
            default : {
                propinsi : null,
                kabupaten : null,
                kecamatan : null,
                kelurahan : null
            }
        }
    },
    components: {
        Dropdown,
    },
    data() {
        return {
            list_propinsi: [],
            list_kabupaten: [],
            list_kecamatan: [],
            list_kelurahan: [],
        };
    },
    computed : {
        model : {
            get() {
                return this.modelValue;
            },
            set(value) {
                // console.log(value);
                this.$emit('update:modelValue', value);
            }
        }
    },
    watch : {
        'modelValue.selected_propinsi' : {
            'handler' : function(newValue, oldValue) {
                if(newValue) {
                    this.getListKabupaten();
                }
            },
            'deep' : true
        },
        'modelValue.selected_kabupaten' : {
            'handler' : function(newValue, oldValue) {
                if(newValue) {
                    this.getListKecamatan();
                }
            },
            'deep' : true
        },
        'modelValue.selected_kecamatan' : {
            'handler' : function(newValue, oldValue) {
                if(newValue) {
                    this.getListKelurahan();
                }
            },
            'deep' : true
        },
        'modelValue.selected_kelurahan' : {
            'handler' : function(newValue, oldValue) {
                if(newValue) {
                    this.getListKelurahan();
                }
            },
            'deep' : true
        }

    },
    methods : {
        getListPropinsi(){
            axios.get('/api/wilayah/propinsi')
            .then(response => {
                // console.log(response.data);
                this.list_propinsi = response.data;
                // if only 1 item, then set it as selected
                if(this.list_propinsi.length == 1) {
                    this.modelValue.selected_propinsi = this.list_propinsi[0];
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        getListKabupaten(){
            axios.get('/api/wilayah/kabupaten/' + this.modelValue.selected_propinsi.kode)
            .then(response => {
                this.list_kabupaten = response.data;

                // if only 1 item, then set it as selected
                if(this.list_kabupaten.length == 1) {
                    this.modelValue.selected_kabupaten = this.list_kabupaten[0];
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        getListKecamatan(){
            axios.get('/api/wilayah/kecamatan/' + this.modelValue.selected_kabupaten.kode)
            .then(response => {
                this.list_kecamatan = response.data;

                // if only 1 item, then set it as selected
                if(this.list_kecamatan.length == 1) {
                    this.modelValue.selected_kecamatan = this.list_kecamatan[0];
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        getListKelurahan(){
            axios.get('/api/wilayah/kelurahan/' + this.modelValue.selected_kecamatan.kode)
            .then(response => {
                this.list_kelurahan = response.data;

                // if only 1 item, then set it as selected
                if(this.list_kelurahan.length == 1) {
                    this.modelValue.selected_kelurahan = this.list_kelurahan[0];
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    mounted() {
        this.getListPropinsi();
        if (this.modelValue.selected_propinsi) {
            this.getListKabupaten();
        }

        if (this.modelValue.selected_kabupaten) {
            this.getListKecamatan();
        }

        if (this.modelValue.selected_kecamatan) {
            this.getListKelurahan();
        }

    },
}
</script>

<style>

</style>